import { render, staticRenderFns } from "./CallTranscription.vue?vue&type=template&id=58f0fe58&scoped=true&"
import script from "./CallTranscription.vue?vue&type=script&lang=ts&"
export * from "./CallTranscription.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./CallTranscription.vue?vue&type=style&index=0&id=58f0fe58&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "58f0fe58",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f0fe58')) {
      api.createRecord('58f0fe58', component.options)
    } else {
      api.reload('58f0fe58', component.options)
    }
    module.hot.accept("./CallTranscription.vue?vue&type=template&id=58f0fe58&scoped=true&", function () {
      api.rerender('58f0fe58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CallTranscription.vue"
export default component.exports